import { memo, useCallback, useContext } from 'react'

import { useTranslate } from '../../../code-only/localization/language-context.ts'
import { Avatar, AvatarDecorative } from '../../../components/index.ts'
import { Menu } from '../../../components/menu/menu.tsx'
import { TrackButtonClickContext } from '../../../wrapper-context.tsx'

export const UserDropdown = memo<{
  firstName?: string
  lastName?: string
  onLogout: () => void
  onOpenAccountPage: () => void
  onOpenChat: () => void
}>(function UserDropdown({ firstName, lastName, onLogout, onOpenAccountPage, onOpenChat }) {
  const translate = useTranslate()
  const trackButtonContext = useContext(TrackButtonClickContext)

  const handleChange = useCallback(
    (value: string | null) => {
      switch (value) {
        case 'ACCOUNT_PAGE':
          onOpenAccountPage()
          return
        case 'CONTACT_CARE':
          // Track the contact advisor click
          trackButtonContext({
            buttonName: 'contact_button',
            buttonText: translate('contact_customer_support'),
            buttonIcon: 'comment-light',
          })
          onOpenChat()
          return
        case 'LOGOUT':
          onLogout()
          return
        case null:
          return
      }
    },
    [onLogout, onOpenAccountPage, onOpenChat, trackButtonContext, translate],
  )

  return (
    <Menu
      buttonLabel={[firstName, lastName].join(' ')}
      buttonAccessoryLeft={
        <AvatarDecorative icon={'circle-user-light'} size="40" backgroundColorToken="color-bg-decorative-1" />
      }
      buttonAccessoryRight={<Avatar icon={'angles-up-down-solid'} size="10" />}
      buttonMaxWidth={'240px'}
      menuItems={[
        { icon: 'arrow-up-right-from-square-regular', label: translate('open_my_customer_app'), value: 'ACCOUNT_PAGE' },
        { icon: 'comment-light', label: translate('contact_customer_support'), value: 'CONTACT_CARE' },
        { icon: 'arrow-right-from-bracket-regular', label: translate('disconnect'), value: 'LOGOUT' },
      ]}
      onChange={handleChange}
      size="medium"
      position="right"
    />
  )
})
